/**
 * AK on-hand inventory module.
 *
 * Shop metafield setup (one-time, Admin):
 *   Settings → Custom data → Shop → Add definition
 *   Namespace: custom | Key: onhand_csv | Type: File | Storefront: Public read
 *   Settings → General → Metafields → upload ONHAND CSV export
 *
 * Expected CSV columns:
 *   item, totalqty, size1, size2, size3, size4, size5, size6, size7, size8
 */
(function () {
  var cache = null;
  var displayRows = null;
  var loadPromise = null;

  function parseCsvLine(line) {
    var cells = [];
    var current = '';
    var inQuotes = false;

    for (var i = 0; i < line.length; i++) {
      var ch = line.charAt(i);

      if (ch === '"') {
        if (inQuotes && line.charAt(i + 1) === '"') {
          current += '"';
          i += 1;
        } else {
          inQuotes = !inQuotes;
        }
      } else if (ch === ',' && !inQuotes) {
        cells.push(current.trim());
        current = '';
      } else {
        current += ch;
      }
    }

    cells.push(current.trim());
    return cells;
  }

  function parseQty(value) {
    if (value == null || value === '') return 0;
    var amount = parseFloat(String(value).trim());
    return Number.isNaN(amount) ? 0 : Math.round(amount);
  }

  function pushDisplayRow(item, totalqty, sizes) {
    var styleNo = (item || '').trim();
    if (!styleNo) return;

    if (!displayRows) displayRows = [];

    displayRows.push({
      styleNo: styleNo,
      inventory: parseQty(totalqty),
      sizes: sizes
    });
  }

  function parseNativeCsv(text) {
    displayRows = [];
    var rows = {};
    var lines = text.split(/\r?\n/).filter(function (line) {
      return line.trim() !== '';
    });

    if (!lines.length) return rows;

    var headers = parseCsvLine(lines[0]);
    var columns = {};

    headers.forEach(function (header, index) {
      columns[header.trim().toLowerCase()] = index;
    });

    for (var i = 1; i < lines.length; i++) {
      var cells = parseCsvLine(lines[i]);

      function getCell(name) {
        var index = columns[name];
        return index != null ? (cells[index] || '').trim() : '';
      }

      var item = getCell('item');
      var sizes = [];

      for (var s = 1; s <= 8; s++) {
        sizes.push(parseQty(getCell('size' + s)));
      }

      var key = item.toUpperCase();
      rows[key] = {
        styleNo: item,
        inventory: parseQty(getCell('totalqty')),
        sizes: sizes
      };

      pushDisplayRow(item, getCell('totalqty'), sizes);
    }

    return rows;
  }

  window.AkOnHand = {
    load: function (csvUrl) {
      if (!csvUrl) return Promise.resolve(null);
      if (cache) return Promise.resolve(cache);
      if (loadPromise) return loadPromise;

      loadPromise = fetch(csvUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('On-hand fetch failed');
          return response.text();
        })
        .then(function (text) {
          displayRows = [];
          cache = parseNativeCsv(text);
          if (displayRows == null) displayRows = [];
          window.debugLog('[AkOnHand] loaded', {
            items: cache,
            rows: displayRows
          });
          return cache;
        })
        .catch(function () {
          cache = null;
          displayRows = null;
          loadPromise = null;
          return null;
        });

      return loadPromise;
    },

    getAllRows: function () {
      return displayRows ? displayRows.slice() : [];
    },

    findBySku: function (sku) {
      if (!cache || !sku) return null;
      return cache[String(sku).trim().toUpperCase()] || null;
    },

    getStyleKey: function (sku) {
      var text = String(sku || '').trim().toUpperCase();
      if (!text) return '';
      var starIndex = text.indexOf('*');
      return starIndex !== -1 ? text.slice(0, starIndex) : text;
    },

    findMatchingRows: function (skus) {
      if (!displayRows || !skus || !skus.length) return [];

      var styleKeys = {};

      skus.forEach(function (sku) {
        var styleKey = window.AkOnHand.getStyleKey(sku);
        if (styleKey) styleKeys[styleKey] = true;
      });

      return displayRows.filter(function (row) {
        return styleKeys[window.AkOnHand.getStyleKey(row.styleNo)];
      });
    },

    isReady: function () {
      return cache != null;
    },

    clear: function () {
      cache = null;
      displayRows = null;
      loadPromise = null;
      this.ready = Promise.resolve(null);
    },

    ready: Promise.resolve(null),

    init: function () {
      var el = document.getElementById('ak-onhand-url');
      if (!el) {
        this.ready = Promise.resolve(null);
        return;
      }

      try {
        var url = JSON.parse(el.textContent);
        this.ready = this.load(url).then(function (result) {
          if (result) {
            document.dispatchEvent(new CustomEvent('ak-onhand:ready'));
          }
          return result;
        });
      } catch (error) {
        this.ready = Promise.resolve(null);
      }
    }
  };

  window.AkOnHand.init();
})();
